import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { CommonSharedModule } from '@shared-modules/common-shared.module';
import { CalendarModule } from 'primeng/calendar';
import { CheckboxModule } from 'primeng/checkbox';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { ReMultiselectModule } from '@common/re-multiselect/re-multiselect.module';
import { DeveloperAgreementComponent } from './developer-agreement.component';
import { LibraryViewModeModule } from '@modules/library/private/library-view-mode/library-view-mode.module';

@NgModule({
  declarations: [DeveloperAgreementComponent],
  imports: [
    CommonModule,
    CommonSharedModule,
    LibraryViewModeModule,
    NgSelectModule,
    CheckboxModule,
    CalendarModule,
    HttpClientModule,
    InputTextareaModule,
    FormsModule,
    ReactiveFormsModule,
    ReMultiselectModule,
  ],
  exports: [DeveloperAgreementComponent],
})
export class DeveloperAgreementModule {}
